<template>
  <div id="faq-page" class="w-full overflow-auto">
    <div class="vx-row">
      <!-- FAQ COL -->
      <div class="vx-col w-full md:w-3/5 lg:w-2/4 mt-12 md:mt-0">
        <vs-popup
          fullscreen
          :title="'Fuel Chart - ' + selected.assetName"
          :active.sync="popupActive"
        >
          <fusioncharts
            v-if="popupActive == true && chartLoaded == true"
            type="timeseries"
            width="100%"
            height="500"
            dataFormat="json"
            :dataSource="dataSource"
          ></fusioncharts>
        </vs-popup>
        <vs-popup
          fullscreen
          :title="'Temperature Chart - ' + selected.assetName"
          :active.sync="popupActive2"
        >
          <fusioncharts
            v-if="popupActive2 == true && chartLoaded2 == true"
            type="timeseries"
            width="100%"
            height="500"
            dataFormat="json"
            :dataSource="dataSource2"
          ></fusioncharts>
        </vs-popup>
        <vx-card>
          <vs-progress
            indeterminate
            color="primary"
            v-if="isLoading == true"
          ></vs-progress>
          <vs-progress
            indeterminate
            color="primary"
            v-if="isLoading2 == true"
          ></vs-progress>
          <div class="vx-card__title">
            <h4>
              Manage <b>{{ assetName }}</b>
            </h4>
          </div>

          <div id="map" ref="map"></div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-2/5 lg:w-2/4 rounded-lg">
        <vx-card
          title="Details"
          v-if="
            selectedUnitDetails != null && selectedUnitDetails.brand != 'asr'
          "
        >
          <vs-list-item
            icon="schedule"
            :title="selectedUnitDetails.lastUpdated"
            subtitle="Updated"
          ></vs-list-item>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon="vpn_key"
                :title="selectedUnitDetails.ignition"
                subtitle="Ignition"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon-pack="feather"
                icon="icon-alert-octagon"
                :title="selectedUnitDetails.idlingStatus"
                subtitle="Idling"
              ></vs-list-item>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon="speed"
                :title="selectedUnitDetails.speed"
                subtitle="Speed"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon-pack="feather"
                icon="icon-aperture"
                :title="selectedUnitDetails.mileage"
                subtitle="Odometer"
              ></vs-list-item>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon-pack="feather"
                icon="icon-thermometer"
                :title="selectedUnitDetails.temp"
                subtitle="Temp"
              ></vs-list-item>
              <vx-tooltip
                color="primary"
                text="Daily Temperature Chart"
                position="left"
              >
                <vs-button
                  v-if="selectedUnitDetails.temp != '-'"
                  color="primary"
                  type="flat"
                  size="small"
                  icon-pack="feather"
                  icon="icon-bar-chart"
                  @click="
                    getTemperatureChart(
                      selectedUnitDetails.assetId,
                      selectedUnitDetails.assetName,
                      selectedUnitDetails.unitId,
                    )
                  "
                ></vs-button>
              </vx-tooltip>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon-pack="feather"
                icon="icon-thermometer"
                :title="selectedUnitDetails.humidity"
                subtitle="Humidity"
              ></vs-list-item>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon="local_gas_station"
                :title="selectedUnitDetails.fuel"
                subtitle="Fuel"
              ></vs-list-item>
              <vx-tooltip
                color="primary"
                text="Daily Fuel Chart"
                position="left"
              >
                <vs-button
                  v-if="selectedUnitDetails.fuel != '-'"
                  type="border"
                  size="small"
                  icon-pack="feather"
                  icon="icon-bar-chart"
                  @click="
                    getRefuelChart(
                      selectedUnitDetails.assetId,
                      selectedUnitDetails.assetName,
                      selectedUnitDetails.unitId,
                    )
                  "
                ></vs-button>
              </vx-tooltip>
            </vs-col>

          </vs-row>

          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon-pack="feather"
                icon="icon-check-circle"
                :title="selectedUnitDetails.status"
                subtitle="Status"
              ></vs-list-item>
            </vs-col>

            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon="bolt"
                :title="selectedUnitDetails.volt"
                subtitle="Voltage"
              ></vs-list-item>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                icon="lock"
                :title="selectedUnitDetails.immobilizer"
                subtitle="Immobilizer"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                icon="signal_cellular_4_bar"
                :title="selectedUnitDetails.gps"
                subtitle="GPS"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                :class="{
                  inputOn: selectedUnitDetails.input.includes('ON') === true,
                }"
                icon="gavel"
                :title="selectedUnitDetails.input"
                subtitle="Input"
              ></vs-list-item>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                icon="explore"
                :title="selectedUnitDetails.heading + '° from North'"
                subtitle="Heading"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                icon="local_shipping"
                :title="selectedUnitDetails.assetType"
                subtitle="Type"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                icon="groups"
                :title="assetGroup"
                subtitle="Group"
              ></vs-list-item>
            </vs-col>
          </vs-row>
          <vs-list-item
            icon="location_on"
            :title="selectedUnitDetails.address"
            subtitle="Location"
          ></vs-list-item>
        </vx-card>
        <vx-card
          title="Details"
          v-if="
            selectedUnitDetails != null && selectedUnitDetails.brand == 'asr'
          "
        >
          <vs-list-item
            icon="schedule"
            :title="selectedUnitDetails.lastUpdated"
            subtitle="Updated"
          ></vs-list-item>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon="vpn_key"
                :title="selectedUnitDetails.ignition"
                subtitle="Ignition"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon-pack="feather"
                icon="icon-alert-octagon"
                :title="selectedUnitDetails.idlingStatus"
                subtitle="Idling"
              ></vs-list-item>
            </vs-col>
          </vs-row>

          <vs-row>
            <!-- <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon="speed"
                :title="selectedUnitDetails.speed"
                subtitle="Speed"
              ></vs-list-item>
            </vs-col> -->
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon-pack="feather"
                icon="icon-check-circle"
                :title="selectedUnitDetails.status"
                subtitle="Status"
              ></vs-list-item>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon="signal_cellular_4_bar"
                :title="selectedUnitDetails.gps"
                subtitle="GPS"
              ></vs-list-item>
            </vs-col>

            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <vs-list-item
                icon="bolt"
                :title="`${selectedUnitDetails.batt}%`"
                subtitle="Battery"
              ></vs-list-item>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                icon="explore"
                :title="selectedUnitDetails.heading + '° from North'"
                subtitle="Heading"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                icon="local_shipping"
                :title="selectedUnitDetails.assetType"
                subtitle="Type"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                icon="groups"
                :title="assetGroup"
                subtitle="Group"
              ></vs-list-item>
            </vs-col>
          </vs-row>
          <vs-list-item
            icon="location_on"
            :title="selectedUnitDetails.address"
            subtitle="Location"
          ></vs-list-item>
        </vx-card>
        <br />
        <vx-card
          v-if="
            selectedUnitDetails != null && selectedUnitDetails.brand != 'asr'
          "
        >
          <div class="vx-card__title">
            <h4>Commands</h4>
          </div>

          <vs-button
            color="danger"
            @click="sendImmoCommandOn"
            v-if="allowImmo.on"
            >TURN ON IMMOBILIZER</vs-button
          >
          <vs-button
            color="warning"
            @click="sendImmoCommandOff"
            v-if="allowImmo.off"
            >TURN OFF IMMOBILIZER</vs-button
          >

          <vs-divider></vs-divider>

          <div class="vx-row">
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="8">
              <vs-input
                v-model="mileageValue"
                type="number"
                placeholder="Enter mileage value"
                label="Mileage Value"
              ></vs-input>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-button
                color="primary"
                @click="sendMileageCommand"
                :disabled="!mileageValue || isLoading3"
                style="margin-top: 20px;"
              >
                <vs-progress
                  indeterminate
                  color="white"
                  v-if="isLoading3"
                ></vs-progress>
                SET MILEAGE
              </vs-button>
            </vs-col>
          </div>
        </vx-card>
        <vx-card
          v-if="
            selectedUnitDetails != null && selectedUnitDetails.brand == 'asr'
          "
        >
          <div class="vx-card__title">
            <h4>Commands</h4>
          </div>

          <vs-button color="success" @click="sendCommand2(1)"
            >MEASURE BP,HR & SPO2</vs-button
          >
          <vs-button color="success" @click="sendCommand2(5)"
            >UPLOAD LOCATION NOW</vs-button
          >
          <vs-button color="success" @click="sendCommand2(2)"
            >FIND MY WATCH</vs-button
          >
          <vs-button color="warning" @click="sendCommand2(6)"
            >CALL / MONITOR HQ</vs-button
          >
          <vs-button color="primary" @click="sendCommand2(7)"
            >VOICE CHAT / INTERCOM HQ</vs-button
          >
          <vs-button color="danger" @click="sendCommand2(3)"
            >TURN OFF WATCH</vs-button
          >
          <vs-button color="danger" @click="sendCommand2(4)"
            >REBOOT WATCH</vs-button
          >
        </vx-card>
      </div>
    </div>
    <VerifyOtpForAction ref="otpGuard" :user-info="userInfo" />
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import VerifyOtpForAction from '@/components/VerifyOtpForAction.vue';
import 'vue2-datepicker/index.css';
import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import TimeSeries from 'fusioncharts/fusioncharts.timeseries';
import moment from 'moment';

export default {
  data() {
    return {
      response: {},
      responseLoaded: false,
      params: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      webMapLocal:
        localStorage.getItem('webmap-hybridview-maptype') || 'roadmap',
      webMapShowPOILocal:
        localStorage.getItem('webmap-hybridview-showpoi') || true,
      poiReferences: [],
      allowImmo: {
        on: false,
        off: false,
      },
      assetGroup: '-',
      isLoading: true,
      isLoading2: false,
      selected: {
        assetName: '',
      },
      chartLoaded: false,
      popupActive: false,
      chartLoaded2: false,
      popupActive2: false,
      dataSource: {
        data: null,
        navigator: {
          enabled: 0,
        },
        extensions: {
          customRangeSelector: {
            enabled: 0,
          },
        },
        chart: {
          animation: 0,
          palettecolors: 'FF0000,0000FF,008000',
          multicanvas: false,
          exportEnabled: 1,
          exportFileName: 'Fuel Chart',
        },
        caption: {
          text: 'Fuel Chart',
        },
        datamarker: null,
        yaxis: [
          {
            min: 0,
            plot: [
              {
                value: 'Fuel',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' litres',
            },
          },
          {
            plot: [
              {
                value: 'Odometer',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: '',
            },
          },
          {
            min: 0,
            max: 200,
            plot: [
              {
                value: 'Speed',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: '',
            },
          },
        ],
      },
      dataSource2: {
        data: null,
        navigator: {
          enabled: 0,
        },
        extensions: {
          customRangeSelector: {
            enabled: 0,
          },
        },
        chart: {
          animation: 0,
          palettecolors: 'FF0000,0000FF,008000',
          multicanvas: false,
          exportEnabled: 1,
          exportFileName: 'Temperature Chart',
        },
        caption: {
          text: 'Temperature Chart',
        },
        datamarker: null,
        yaxis: [
          {
            min: 0,
            plot: [
              {
                value: 'Temperature',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' °C',
            },
          },
          {
            min: 0,
            plot: [
              {
                value: 'Preferred_Temperature',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' °C',
            },
          },
          {
            plot: [
              {
                value: 'Odometer',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: '',
            },
          },
          {
            min: 0,
            max: 200,
            plot: [
              {
                value: 'Speed',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: '',
            },
          },
        ],
      },
      loader: null,
      assetName: this.$route.params.assetName,
      assetId: this.$route.params.assetId,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      selection: {
        timeRange: '',
      },
      gmarkers: [],
      units: [],
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      selectedUnitsUnrefined: { id: 1, type: 'ALL', label: 'All Assets' },
      selectedUnitsRefined: [],

      mapMarkerData: [],
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
      geoPOIData: JSON.parse(localStorage.getItem('geoPOIData')),
      selectedUnitDetails: null,
      map: null,
      popup: null,
      selectedRouteArray: [],
      isPlaying: false,
      showTrack: false,
      routePath: [],
      playbackMarker: '',
      playbackLng: '',
      playbackLat: '',
      isPlaying: false,
      selectedPlaybackIndex: 0,
      mileageValue: '',
      isLoading3: false,
    };
  },
  components: {
    vSelect,
    DatePicker,
    VueFusionCharts,
    FusionCharts,
    TimeSeries,
    moment,
    VerifyOtpForAction,
  },
  mounted() {
    const self = this;
    const access = self.userInfo.access.actions;
    if (access.includes('immo-on')) {
      self.allowImmo.on = true;
    }
    if (access.includes('immo-off')) {
      self.allowImmo.off = true;
    }
    self.unitSelection.forEach((element) => {
      if (
        element.assetId == self.assetId &&
        element.assetName == self.assetName
      ) {
        self.assetGroup = element.assetGroup;
      }
    });
    self.getDetails();
  },
  methods: {
    sendCommand2(mode) {
      try {
        const self = this;
        const brand = self.selectedUnitDetails.brand;
        const unitId = self.selectedUnitDetails.unitId;
        const params = {};
        let nFunction;
        if (mode == 1) {
          nFunction = 'hrtstart';
        } else if (mode == 2) {
          nFunction = 'FIND';
        } else if (mode == 3) {
          nFunction = 'POWEROFF';
        } else if (mode == 4) {
          nFunction = 'RESET';
        } else if (mode == 5) {
          nFunction = 'CR';
        } else if (mode == 6) {
          nFunction = 'MONITOR';
        } else if (mode == 7) {
          nFunction = 'TK';
        }
        self.isLoading = true;
        self.responseLoaded = false;
        self.response = {};
        setTimeout(() => {
          self.isLoading = false;
          return self.$vs.notify({
            title: 'Command Sent Succesfully!',
            text: 'Wait for upto 5minutes for changes to reflect..',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
          });
        }, 6000);
        self.$http
          .post('/admin/commands2', {
            brand,
            unitId,
            params,
            nFunction,
            p1: self.params[0],
            p2: self.params[1],
            p3: self.params[2],
            p4: self.params[3],
            p5: self.params[4],
            p6: self.params[5],
            p7: self.params[6],
            p8: self.params[7],
            p9: self.params[8],
            p10: self.params[9],
            p11: self.params[10],
            p12: self.params[11],
            p13: self.params[12],
            p14: self.params[13],
          })
          .then(function (response) {})
          .catch(function (error) {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          });
      } catch (error) {
        console.error(error);
      }
    },
    addCenterControl(controlDiv, map) {
      const self = this;
      const controlUI = document.createElement('div');

      controlUI.innerHTML = `
        <div style="color: black; background: white;font-size:12px; padding:13px;margin-top:9px;font-family:roboto;cursor: pointer;">
          Toggle POI

        </div>
      `;

      controlDiv.appendChild(controlUI);
      controlUI.addEventListener('click', () => {
        if (self.webMapShowPOILocal == true) {
          if (self.poiReferences.length != 0) {
            for (let i = 0; i < self.poiReferences.length; i++) {
              self.poiReferences[i].setMap(null);
            }
            self.poiReferences = [];
            self.webMapShowPOILocal = false;
            localStorage.setItem('webmap-hybridview-showpoi', false);
          }
        } else {
          self.poiReferences = [];
          self.webMapShowPOILocal = true;
          localStorage.setItem('webmap-hybridview-showpoi', true);
          const poi = self.mapPOIData.map((data, i) => {
            const poi = new google.maps.Polygon(data);
            self.poiReferences.push(poi);
            google.maps.event.addListener(poi, 'click', function (event) {
              alert(data.metadata.name);
            });
            poi.setMap(self.map);

            return poi;
          });
        }
      });
    },
    getTemperatureChart(assetId, assetName, unitId) {
      const self = this;
      self.isLoading = true;
      self.selected.assetName = assetName;
      self.$http
        .post(`temperatureChart/${assetId}/${self.userInfo.uid}/${unitId}`, {
          timeRange: 'daily',
          geoPOIData: self.geoPOIData,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            const data = response.data.series;
            self.dataSource2 = {
              data: null,
              navigator: {
                enabled: 0,
              },
              extensions: {
                customRangeSelector: {
                  enabled: 0,
                },
              },
              chart: {
                animation: 0,
                palettecolors: '800080,000000,0000FF,008000',
                multicanvas: false,
                exportEnabled: 1,
                exportFileName: 'Temperature Chart',
              },
              caption: {
                text: `Temperature Chart -${assetName}`,
              },
              datamarker: null,
              yaxis: [
                {
                  min: 0,
                  plot: [
                    {
                      value: 'Temperature_1',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: ' °C',
                  },
                },
                {
                  min: 0,
                  plot: [
                    {
                      value: 'Temperature_2',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: ' °C',
                  },
                },
                {
                  min: 0,
                  plot: [
                    {
                      value: 'Temperature_3',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: ' °C',
                  },
                },
                {
                  min: 0,
                  plot: [
                    {
                      value: 'Temperature_4',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: ' °C',
                  },
                },
                {
                  min: 0,
                  plot: [
                    {
                      value: 'Preferred_Temperature',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: ' °C',
                  },
                },
                {
                  plot: [
                    {
                      value: 'Odometer',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: '',
                  },
                },
                {
                  min: 0,
                  max: 200,
                  plot: [
                    {
                      value: 'Speed',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: '',
                  },
                },
              ],
            };
            self.dataSource2.datamarker = response.data.datamarker;
            const dataSchema = response.data.dataSchema;
            const fusionTable = new FusionCharts.DataStore().createDataTable(
              data,
              dataSchema,
            );
            self.dataSource2.data = fusionTable;
            self.isLoading = false;
            self.popupActive2 = true;
            self.chartLoaded2 = true;
          } else {
            self.isLoading = false;
            if (response.data.error) {
            } else {
            }
          }
        })
        .catch(function (error) {
          self.isLoading = false;
        });
    },
    getRefuelChart(assetId, assetName, unitId) {
      const self = this;
      self.isLoading = true;
      self.selected.assetName = assetName;
      self.$http
        .post(`refuelChart/${assetId}/${self.userInfo.uid}/${unitId}`, {
          timeRange: 'daily',
          geoPOIData: self.geoPOIData,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            const data = response.data.series;
            self.dataSource = {
              data: null,
              navigator: {
                enabled: 0,
              },
              extensions: {
                customRangeSelector: {
                  enabled: 0,
                },
              },
              chart: {
                animation: 0,
                palettecolors: 'FF0000,0000FF,008000',
                multicanvas: false,
                exportEnabled: 1,
                exportFileName: 'Fuel Chart',
              },
              caption: {
                text: `Fuel Chart -${assetName}`,
              },
              datamarker: null,
              yaxis: [
                {
                  min: 0,
                  plot: [
                    {
                      value: 'Fuel',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: ' litres',
                  },
                },
                {
                  plot: [
                    {
                      value: 'Odometer',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: '',
                  },
                },
                {
                  min: 0,
                  max: 200,
                  plot: [
                    {
                      value: 'Speed',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: '',
                  },
                },
              ],
            };
            self.dataSource.datamarker = response.data.datamarker;

            const dataSchema = response.data.dataSchema;
            if (response.data.type == 2) {
              self.dataSource.chart.palettecolors =
                'FF0000,FFD700,0000FF,008000';
              self.dataSource.yaxis = [
                {
                  min: 0,
                  plot: [
                    {
                      value: 'Fuel',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: ' litres',
                  },
                },
                {
                  min: 0,
                  plot: [
                    {
                      value: 'Fuel2',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: ' litres',
                  },
                },
                {
                  plot: [
                    {
                      value: 'Odometer',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: '',
                  },
                },
                {
                  min: 0,
                  max: 200,
                  plot: [
                    {
                      value: 'Speed',
                      connectnulldata: true,
                      type: 'line',
                    },
                  ],
                  format: {
                    suffix: '',
                  },
                },
              ];
            }

            const fusionTable = new FusionCharts.DataStore().createDataTable(
              data,
              dataSchema,
            );
            self.dataSource.data = fusionTable;
            self.isLoading = false;
            self.popupActive = true;
            self.chartLoaded = true;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },

    sendImmoCommandOn() {
      const self = this;
      const run = () => {
        const r = confirm(
          'This will cause the vehicle to STOP instantly which may be dangerous to the Driver & Vehicle, only do it vehicle is Parked/Idling. If unsure, contact our Support Team for assistance. Click OK to proceed at your own risk.',
        );
        if (r != true) return;
        try {
          self.isLoading2 = true;
          const brand = self.selectedUnitDetails.brand;
          const unitId = self.selectedUnitDetails.unitId;

          self.$http
            .post(`command/immobilizerOn2/${brand}/${unitId}`, {
              type: 'Web',
              userInfo: self.userInfo,
              assetName: self.assetName,
            })
            .then(function (response) {
              setTimeout(() => {
                self.isLoading2 = false;
              }, 3000);

              if (response.status == 200 && response.data.success) {
                self.$vs.notify({
                  title: 'Command Response',
                  text: response.data.results,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success',
                });
              } else if (response.data.error) {
                return self.$vs.notify({
                  title: 'Unable to Send Immo Command',
                  text: response.data.error,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success',
                });
              } else {
                return self.$vs.notify({
                  title: 'Unable to Send Immo Command',
                  text: 'Try again later..',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success',
                });
              }
            })
            .catch(function (error) {});
        } catch (error) {
          console.error(error);
        }
      };
      if (this.$refs.otpGuard) {
        this.$refs.otpGuard.runIfVerified(run);
      } else {
        run();
      }
    },
    removeMarkers() {
      const self = this;

      for (let i = 0; i < self.gmarkers.length; i++) {
        self.gmarkers[i].setMap(null);
      }
    },
    sendImmoCommandOff() {
      const self = this;
      const run = () => {
        const r = confirm(
          'This will cause the immobilizer to be turned OFF. If unsure, contact our Support Team for assistance. Click OK to proceed at your own risk.',
        );
        if (r != true) return;
        try {
          self.isLoading2 = true;
          const brand = self.selectedUnitDetails.brand;
          const unitId = self.selectedUnitDetails.unitId;

          self.$http
            .post(`command/immobilizerOff2/${brand}/${unitId}`, {
              type: 'Web',
              userInfo: self.userInfo,
              assetName: self.assetName,
            })
            .then(function (response) {
              setTimeout(() => {
                self.isLoading2 = false;
              }, 3000);
              if (response.status == 200 && response.data.success) {
                self.$vs.notify({
                  title: 'Command Response',
                  text: response.data.results,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success',
                });
              } else if (response.data.error) {
                return self.$vs.notify({
                  title: 'Unable to Send Immo Command',
                  text: response.data.error,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success',
                });
              } else {
                return self.$vs.notify({
                  title: 'Unable to Send Immo Command',
                  text: 'Try again later..',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success',
                });
              }
            })
            .catch(function (error) {});
        } catch (error) {
          console.error(error);
        }
      };
      if (this.$refs.otpGuard) {
        this.$refs.otpGuard.runIfVerified(run);
      } else {
        run();
      }
    },
    sendMileageCommand() {
      if (!this.mileageValue || this.mileageValue <= 0) {
        this.$vs.notify({
          title: 'Invalid Mileage Value',
          text: 'Please enter a valid mileage value greater than 0.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
        return;
      }

      const self = this;
      const run = () => {
        const r = confirm(
          `Are you sure you want to set the mileage to ${self.mileageValue}? This action cannot be undone.`,
        );
        if (r != true) return;
        try {
          self.isLoading3 = true;
          const brand = self.selectedUnitDetails.brand;
          const unitId = self.selectedUnitDetails.unitId;

          self.$http
            .post(`command/setMileage/${brand}/${unitId}`, {
              type: 'Web',
              userInfo: self.userInfo,
              assetName: self.assetName,
              mileageValue: self.mileageValue,
            })
            .then(function (response) {
              setTimeout(() => {
                self.isLoading3 = false;
              }, 3000);

              if (response.status == 200 && response.data.success) {
                self.$vs.notify({
                  title: 'Command Response',
                  text: response.data.results,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success',
                });
                self.mileageValue = '';
              } else if (response.data.error) {
                return self.$vs.notify({
                  title: 'Unable to Send Mileage Command',
                  text: response.data.error,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger',
                });
              } else {
                return self.$vs.notify({
                  title: 'Unable to Send Mileage Command',
                  text: 'Try again later..',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger',
                });
              }
            })
            .catch(function (error) {
              self.isLoading3 = false;
              self.$vs.notify({
                title: 'Error',
                text: 'Failed to send mileage command. Please try again.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
              });
            });
        } catch (error) {
          console.error(error);
          this.isLoading3 = false;
        }
      };
      if (this.$refs.otpGuard) {
        this.$refs.otpGuard.runIfVerified(run);
      } else {
        run();
      }
    },
    getDetails() {
      const self = this;
      self.loader = new Loader(this.$loader);
      const assetId = self.assetId;
      self.selectedUnitDetails = null;

      self.$http
        .post(`manageUnitv2/${assetId}/${self.userInfo.uid}`, {
          geoPOIData: self.geoPOIData,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.selectedUnitDetails = response.data.unitDetails;
            // self.mapPOIData = response.data.mapPOIData;

            self.loader.load().then(() => {
              self.map = new google.maps.Map(self.$refs.map, {
                center: {
                  lat: self.selectedUnitDetails.lat,
                  lng: self.selectedUnitDetails.lng,
                },
                zoom: 16,
                gestureHandling: 'greedy',
                mapTypeId: self.webMapLocal,
              });

              const marker = new google.maps.Marker({
                position: {
                  lat: self.selectedUnitDetails.lat,
                  lng: self.selectedUnitDetails.lng,
                },
                //  label:{text:self.selectedUnitDetails.assetName,color:'black',fontSize:'14px',align:'center',fontWeight:'bold'},
                icon: self.selectedUnitDetails.icon,
                metadata: { assetId: self.selectedUnitDetails.assetId },
              });
              self.gmarkers.push(marker);
              marker.setMap(self.map);

              new google.maps.event.addListener(
                self.map,
                'maptypeid_changed',
                function () {
                  const newMapType = self.map.getMapTypeId();
                  localStorage.setItem('webmap-hybridview-maptype', newMapType);
                },
              );
              if (self.webMapShowPOILocal == true) {
                const poi = self.mapPOIData.map((data, i) => {
                  const poi = new google.maps.Polygon(data);
                  self.poiReferences.push(poi);
                  google.maps.event.addListener(poi, 'click', function (event) {
                    alert(data.metadata.name);
                  });
                  poi.setMap(self.map);

                  return poi;
                });
              }
              const centerControlDiv = document.createElement('div');
              self.addCenterControl(centerControlDiv, self.map);
              self.map.controls[google.maps.ControlPosition.TOP_LEFT].push(
                centerControlDiv,
              );
            });

            self.isLoading = false;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
  },
  created() {},
};
</script>

<style>
#map {
  height: 80vh;
}

button {
  position: absolute;
  margin: 20px;
}

#pause::after {
  content: 'Pause';
}

#pause.pause::after {
  content: 'Play';
}

@-webkit-keyframes inputOn {
  from {
    background-color: #3e1cff;
  }
  to {
    background-color: inherit;
  }
}
@-moz-keyframes inputOn {
  from {
    background-color: #3e1cff;
  }
  to {
    background-color: inherit;
  }
}
@-o-keyframes inputOn {
  from {
    background-color: #3e1cff;
  }
  to {
    background-color: inherit;
  }
}
@keyframes inputOn {
  from {
    background-color: #3e1cff;
  }
  to {
    background-color: inherit;
  }
}
.inputOn {
  -webkit-animation: inputOn 2s infinite; /* Safari 4+ */
  -moz-animation: inputOn 2s infinite; /* Fx 5+ */
  -o-animation: inputOn 2s infinite; /* Opera 12+ */
  animation: inputOn 2s infinite; /* IE 10+ */
}
</style>
